import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../utils/TestIds';
import styles from './BulletList.module.scss';
export const GetBulletListTID = (parentTestId)=>getTestIds(parentTestId);
export const BulletList = (param)=>{
    let { children, spacing = 'default', className, testId } = param;
    const { BulletListTestIds } = useMemo(()=>GetBulletListTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx("ul", {
        className: cn(styles.root, styles[spacing], className),
        "data-testid": BulletListTestIds.Root(),
        children: children
    });
};
